module.exports = __webpack_public_path__ + "static/media/icon_play_empty.0a2321d1.svg";